// extracted by mini-css-extract-plugin
export default {"container":"loadingSpinner_container__ecbn4","spinner":"loadingSpinner_spinner__W8C4E","rotate":"loadingSpinner_rotate__xRJ0S","text":"loadingSpinner_text__XesBT"};